import Layout from "../components/Layout";

export default function AIPage() {
  return (
    <Layout>
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-text">
          <h1>Artificial Intelligence</h1>
          <p>
            The future of organisation is in Artificial Intelligence, and TearabyteSS can help your business get in on the action. Don't get left behind-integrate modern software technology into your operations!
          </p>
        </div>
        <div className="hero-visuals">
          <img src="/assets/images/aiHero.png" alt="AI Hero Visuals" />
        </div>
      </section>

      {/* GPT Integration */}
      <section className="intro-section">
        <h2>Integrate GPT Models into Your Business</h2>
        <p>
          GPT systems offer unparalleled capabilities in information processing, content generation, question answering, and product innovation. Leverage these advanced models to streamline data analysis and enhance productivity across your operations.
        </p>
      </section>

      {/* Email Campaigns */}
      {/* <section className="split-section">
        <div className="split-text">
          <h3>AI Email Campaigns</h3>
          <p>
            Unlock the power of personalised communication with our cutting-edge Automated Email Customisation service. We design visually stunning emails tailored to your brand's identity and harness the power of AI to ensure each message resonates personally with every recipient.
          </p>
          <p>
            We're offering a free one-month trial to our first users! Start today and experience the future of email marketing.
          </p>
          <a className="contactLink" href="/emailSenders">
            Learn More
          </a>
        </div>
        <div className="split-image">
          <img src="/assets/images/emailSenders.webp" alt="AI Email Campaigns" />
        </div>
      </section> */}

      {/* Website Bots */}
      <section className="split-section reverse">
        <div className="split-text">
          <h3>Enhance Customer Experience with Website Bots</h3>
          <p>
            Ensuring that customers find all the necessary information on your website can be challenging.
            <br /><br />
            By implementing website bot-widgets, you empower customers to ask questions and receive tailored responses instantly, improving engagement and satisfaction.
          </p>
        </div>
        <div className="split-image">
          <img src="/assets/images/webBots.png" alt="Website Bots" />
        </div>
      </section>

      {/* Internal Chat */}
      <section className="split-section">
        <div className="split-text">
          <h3>Streamline Internal Communication</h3>
          <p>
            Your team spends valuable time navigating numerous documents and databases to find necessary information. Our internal chatbot provides immediate access to essential data through simple queries-like your own, personalised internal chatGPT.
          </p>
        </div>
        <div className="split-image">
          <img src="/assets/images/internalCom.png" alt="Internal Chatbot" />
        </div>
      </section>

      {/* Machine Learning */}
      <section className="intro-section">
        <h2>Harness Machine Learning to Decode Customer Insights</h2>
        <p>
          Utilise the power of machine learning to predict customer behavior and gain invaluable insights into their preferences. With AI-driven analytics, you can refine your products, optimise marketing strategies, and deliver personalised experiences.
        </p>
      </section>

      {/* Recommender Systems */}
      <section className="split-section reverse">
        <div className="split-text">
          <h3>Personalised Recommendations for Enhanced Customer Experiences</h3>
          <p>
            Recommender systems suggest relevant products tailored to each customer's preferences, enhancing shopping experiences and driving sales.
          </p>
        </div>
        <div className="split-image">
          <img src="/assets/images/recommenderSystem.png" alt="Recommender Systems" />
        </div>
      </section>

      {/* Predictive Customer Support */}
      <section className="split-section">
        <div className="split-text">
          <h3>Anticipate Customer Needs with Predictive Customer Support</h3>
          <p>
            Leverage machine learning models for predictive support, foreseeing and addressing customer needs proactively.
          </p>
          <h4 style={{ marginTop: "1rem" }}>How can we use this for you?</h4>
          <ul>
            <li>Forecast necessary stock based on trends</li>
            <li>Personalise outreach with targeted messages</li>
            <li>Identify new customer categories and expand your reach</li>
          </ul>
        </div>
        <div className="split-image">
          <img src="/assets/images/predictive.png" alt="Predictive Customer Support" />
        </div>
      </section>

      {/* Contact CTA */}
      <section className="contact-cta">
        <h2>Interested? Contact us for a quote!</h2>
        <a className="contactLink" href="/contact">
          Get in Touch
        </a>
      </section>
    </Layout>
  );
}
